import { render, staticRenderFns } from "./category-summary.vue?vue&type=template&id=3e20c7bb&scoped=true"
import script from "./category-summary.vue?vue&type=script&lang=js"
export * from "./category-summary.vue?vue&type=script&lang=js"
import style0 from "./category-summary.vue?vue&type=style&index=0&id=3e20c7bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e20c7bb",
  null
  
)

export default component.exports